import React from 'react'
import AdmAttendanceDashboard from "../../components/AdminTabs/AdminAttendanceDashboard/AdmAttendanceDashboard"

const AttendanceDashboard = () => {
  return (
    <div>
      <AdmAttendanceDashboard/>
    </div>
  )
}

export default AttendanceDashboard